import { inject } from '@vue/composition-api';import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "regenerator-runtime/runtime.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import Vue from 'vue';
import Vuex from 'vuex';
import Meta from 'vue-meta';
import ClientOnly from 'vue-client-only';
import NoSsr from 'vue-no-ssr';
import { createRouter } from './router.js';
import NuxtChild from './components/nuxt-child.js';
import NuxtError from './components/nuxt-error.vue';
import Nuxt from './components/nuxt.js';
import App from './App.js';
import { setContext, getLocation, getRouteData, normalizeError } from './utils';
import { createStore } from './store.js';
/* Plugins */

import nuxt_plugin_plugin_137ca0d0 from 'nuxt_plugin_plugin_137ca0d0'; // Source: ./components/plugin.js (mode: 'all')

import nuxt_plugin_appplugin_78aee868 from 'nuxt_plugin_appplugin_78aee868'; // Source: ../node_modules/@nuxt/bridge/dist/runtime/app.plugin.mjs (mode: 'all')

import nuxt_plugin_gtm_37aa0c3c from 'nuxt_plugin_gtm_37aa0c3c'; // Source: ./gtm.js (mode: 'all')

import nuxt_plugin_pluginutils_26c07315 from 'nuxt_plugin_pluginutils_26c07315'; // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')

import nuxt_plugin_pluginrouting_2e708f20 from 'nuxt_plugin_pluginrouting_2e708f20'; // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')

import nuxt_plugin_pluginmain_1057b04f from 'nuxt_plugin_pluginmain_1057b04f'; // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')

import nuxt_plugin_dayjsplugin_ae977392 from 'nuxt_plugin_dayjsplugin_ae977392'; // Source: ./dayjs-plugin.js (mode: 'all')

import nuxt_plugin_modalclient_32315286 from 'nuxt_plugin_modalclient_32315286'; // Source: ./modal.client.js (mode: 'client')

import nuxt_plugin_toastclient_0d4b5d80 from 'nuxt_plugin_toastclient_0d4b5d80'; // Source: ./toast.client.js (mode: 'client')

import nuxt_plugin_helper_6f2bf604 from 'nuxt_plugin_helper_6f2bf604'; // Source: ./helper.js (mode: 'all')

import nuxt_plugin_icon_0a99f419 from 'nuxt_plugin_icon_0a99f419'; // Source: ./icon.js (mode: 'all')

import nuxt_plugin_nuxtsvgsprite_1fd790f8 from 'nuxt_plugin_nuxtsvgsprite_1fd790f8'; // Source: ./nuxt-svg-sprite.js (mode: 'all')

import nuxt_plugin_axios_566d83e6 from 'nuxt_plugin_axios_566d83e6'; // Source: ./axios.js (mode: 'all')

import nuxt_plugin_capiplugin_26f5feed from 'nuxt_plugin_capiplugin_26f5feed'; // Source: ./capi.plugin.mjs (mode: 'all')

import nuxt_plugin_nitrobridgeserver_499647d8 from 'nuxt_plugin_nitrobridgeserver_499647d8'; // Source: ./nitro-bridge.server.mjs (mode: 'server')

import nuxt_plugin_nitroclient_33e93c60 from 'nuxt_plugin_nitroclient_33e93c60'; // Source: ./nitro.client.mjs (mode: 'client')

import nuxt_plugin_echo_7481157c from 'nuxt_plugin_echo_7481157c'; // Source: ../plugins/echo.js (mode: 'client')

import nuxt_plugin_gtm_5e4639ea from 'nuxt_plugin_gtm_5e4639ea'; // Source: ../plugins/gtm (mode: 'all')

import nuxt_plugin_flareclient_5d98532c from 'nuxt_plugin_flareclient_5d98532c'; // Source: ../plugins/flare.client.ts (mode: 'client')

import nuxt_plugin_auth_fb39deec from 'nuxt_plugin_auth_fb39deec'; // Source: ./auth.js (mode: 'all')
// Component: <ClientOnly>

Vue.component(ClientOnly.name, ClientOnly); // TODO: Remove in Nuxt 3: <NoSsr>

Vue.component(NoSsr.name, _objectSpread(_objectSpread({}, NoSsr), {}, {
  render: function render(h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true;
      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead');
    }

    return NoSsr.render(h, ctx);
  }
})); // Component: <NuxtChild>

Vue.component(NuxtChild.name, NuxtChild);
Vue.component('NChild', NuxtChild); // Component NuxtLink is imported in server.js or client.js
// Component: <Nuxt>

Vue.component(Nuxt.name, Nuxt);
Object.defineProperty(Vue.prototype, '$nuxt', {
  get: function get() {
    var globalNuxt = this.$root ? this.$root.$options.$nuxt : null;

    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt;
    }

    return globalNuxt;
  },
  configurable: true
});
Vue.use(Meta, {
  "keyName": "head",
  "attribute": "data-n-head",
  "ssrAttribute": "data-n-head-ssr",
  "tagIDKeyName": "hid"
});
var defaultTransition = {
  "name": "page",
  "mode": "out-in",
  "appear": false,
  "appearClass": "appear",
  "appearActiveClass": "appear-active",
  "appearToClass": "appear-to"
};
var originalRegisterModule = Vuex.Store.prototype.registerModule;

function registerModule(path, rawModule) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var preserveState = process.client && (Array.isArray(path) ? !!path.reduce(function (namespacedState, path) {
    return namespacedState && namespacedState[path];
  }, this.state) : path in this.state);
  return originalRegisterModule.call(this, path, rawModule, _objectSpread({
    preserveState: preserveState
  }, options));
}

function createApp(_x) {
  return _createApp.apply(this, arguments);
}

function _createApp() {
  _createApp = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(ssrContext) {
    var config,
        store,
        router,
        app,
        next,
        route,
        path,
        inject,
        _args2 = arguments;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            inject = function _inject(key, value) {
              if (!key) {
                throw new Error('inject(key, value) has no key provided');
              }

              if (value === undefined) {
                throw new Error("inject('".concat(key, "', value) has no value provided"));
              }

              key = '$' + key; // Add into app

              app[key] = value; // Add into context

              if (!app.context[key]) {
                app.context[key] = value;
              } // Add into store


              store[key] = app[key]; // Check if plugin not already installed

              var installKey = '__nuxt_' + key + '_installed__';

              if (Vue[installKey]) {
                return;
              }

              Vue[installKey] = true; // Call Vue.use() to install the plugin into vm

              Vue.use(function () {
                if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
                  Object.defineProperty(Vue.prototype, key, {
                    get: function get() {
                      return this.$root.$options[key];
                    }
                  });
                }
              });
            };

            config = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
            store = createStore(ssrContext);
            _context2.next = 5;
            return createRouter(ssrContext, config, {
              store: store
            });

          case 5:
            router = _context2.sent;
            // Add this.$router into store actions/mutations
            store.$router = router; // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141

            store.registerModule = registerModule; // Create Root instance
            // here we inject the router and store to all child components,
            // making them available everywhere as `this.$router` and `this.$store`.

            app = _objectSpread({
              head: {
                "title": "Gradlinc",
                "htmlAttrs": {
                  "lang": "en"
                },
                "meta": [{
                  "charset": "utf-8"
                }, {
                  "name": "viewport",
                  "content": "width=device-width, initial-scale=1"
                }, {
                  "hid": "description",
                  "name": "description",
                  "content": ""
                }, {
                  "name": "format-detection",
                  "content": "telephone=no"
                }],
                "link": [{
                  "rel": "icon",
                  "type": "image/x-icon",
                  "href": "/favicon.ico"
                }, {
                  "rel": "icon",
                  "type": "image/png",
                  "sizes": "32x32",
                  "href": "/favicon-32x32.png"
                }, {
                  "rel": "icon",
                  "type": "image/png",
                  "sizes": "16x16",
                  "href": "/favicon-16x16.png"
                }, {
                  "rel": "stylesheet",
                  "href": "https://fonts.googleapis.com/css2?family=Mulish:wght@300;400;500;700;800&display=swap"
                }, {
                  "rel": "stylesheet",
                  "href": "https://unpkg.com/vue-multiselect@2.1.0/dist/vue-multiselect.min.css"
                }],
                "script": [{
                  "src": "https://maps.googleapis.com/maps/api/js?key=AIzaSyBOWGePIIa0njk9HRos3GysItN8CR7HrQs&libraries=places&callback=Function.prototype"
                }, {
                  "hid": "gtm-script",
                  "innerHTML": "if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-NRPCHDG')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"
                }],
                "style": [],
                "noscript": [{
                  "hid": "gtm-noscript",
                  "pbody": true,
                  "innerHTML": "<iframe src=\"https://www.googletagmanager.com/ns.html?id=GTM-NRPCHDG&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"></iframe>"
                }],
                "__dangerouslyDisableSanitizersByTagID": {
                  "gtm-script": ["innerHTML"],
                  "gtm-noscript": ["innerHTML"]
                }
              },
              store: store,
              router: router,
              nuxt: {
                defaultTransition: defaultTransition,
                transitions: [defaultTransition],
                setTransitions: function setTransitions(transitions) {
                  if (!Array.isArray(transitions)) {
                    transitions = [transitions];
                  }

                  transitions = transitions.map(function (transition) {
                    if (!transition) {
                      transition = defaultTransition;
                    } else if (typeof transition === 'string') {
                      transition = Object.assign({}, defaultTransition, {
                        name: transition
                      });
                    } else {
                      transition = Object.assign({}, defaultTransition, transition);
                    }

                    return transition;
                  });
                  this.$options.nuxt.transitions = transitions;
                  return transitions;
                },
                err: null,
                dateErr: null,
                error: function error(err) {
                  err = err || null;
                  app.context._errored = Boolean(err);
                  err = err ? normalizeError(err) : null;
                  var nuxt = app.nuxt; // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207

                  if (this) {
                    nuxt = this.nuxt || this.$options.nuxt;
                  }

                  nuxt.dateErr = Date.now();
                  nuxt.err = err; // Used in src/server.js

                  if (ssrContext) {
                    ssrContext.nuxt.error = err;
                  }

                  return err;
                }
              }
            }, App); // Make app available into store via this.app

            store.app = app;
            next = ssrContext ? ssrContext.next : function (location) {
              return app.router.push(location);
            }; // Resolve route

            if (ssrContext) {
              route = router.resolve(ssrContext.url).route;
            } else {
              path = getLocation(router.options.base, router.options.mode);
              route = router.resolve(path).route;
            } // Set context to app.context


            _context2.next = 14;
            return setContext(app, {
              store: store,
              route: route,
              next: next,
              error: app.nuxt.error.bind(app),
              payload: ssrContext ? ssrContext.payload : undefined,
              req: ssrContext ? ssrContext.req : undefined,
              res: ssrContext ? ssrContext.res : undefined,
              beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
              beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
              ssrContext: ssrContext
            });

          case 14:
            // Inject runtime config as $config
            inject('config', config);

            if (process.client) {
              // Replace store state before plugins execution
              if (window.__NUXT__ && window.__NUXT__.state) {
                store.replaceState(window.__NUXT__.state);
              }
            } // Add enablePreview(previewData = {}) in context for plugins


            if (process.static && process.client) {
              app.context.enablePreview = function () {
                var previewData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                app.previewData = Object.assign({}, previewData);
                inject('preview', previewData);
              };
            } // Plugin execution


            if (!(typeof nuxt_plugin_plugin_137ca0d0 === 'function')) {
              _context2.next = 20;
              break;
            }

            _context2.next = 20;
            return nuxt_plugin_plugin_137ca0d0(app.context, inject);

          case 20:
            if (!(typeof nuxt_plugin_appplugin_78aee868 === 'function')) {
              _context2.next = 23;
              break;
            }

            _context2.next = 23;
            return nuxt_plugin_appplugin_78aee868(app.context, inject);

          case 23:
            if (!(typeof nuxt_plugin_gtm_37aa0c3c === 'function')) {
              _context2.next = 26;
              break;
            }

            _context2.next = 26;
            return nuxt_plugin_gtm_37aa0c3c(app.context, inject);

          case 26:
            if (!(typeof nuxt_plugin_pluginutils_26c07315 === 'function')) {
              _context2.next = 29;
              break;
            }

            _context2.next = 29;
            return nuxt_plugin_pluginutils_26c07315(app.context, inject);

          case 29:
            if (!(typeof nuxt_plugin_pluginrouting_2e708f20 === 'function')) {
              _context2.next = 32;
              break;
            }

            _context2.next = 32;
            return nuxt_plugin_pluginrouting_2e708f20(app.context, inject);

          case 32:
            if (!(typeof nuxt_plugin_pluginmain_1057b04f === 'function')) {
              _context2.next = 35;
              break;
            }

            _context2.next = 35;
            return nuxt_plugin_pluginmain_1057b04f(app.context, inject);

          case 35:
            if (!(typeof nuxt_plugin_dayjsplugin_ae977392 === 'function')) {
              _context2.next = 38;
              break;
            }

            _context2.next = 38;
            return nuxt_plugin_dayjsplugin_ae977392(app.context, inject);

          case 38:
            if (!(process.client && typeof nuxt_plugin_modalclient_32315286 === 'function')) {
              _context2.next = 41;
              break;
            }

            _context2.next = 41;
            return nuxt_plugin_modalclient_32315286(app.context, inject);

          case 41:
            if (!(process.client && typeof nuxt_plugin_toastclient_0d4b5d80 === 'function')) {
              _context2.next = 44;
              break;
            }

            _context2.next = 44;
            return nuxt_plugin_toastclient_0d4b5d80(app.context, inject);

          case 44:
            if (!(typeof nuxt_plugin_helper_6f2bf604 === 'function')) {
              _context2.next = 47;
              break;
            }

            _context2.next = 47;
            return nuxt_plugin_helper_6f2bf604(app.context, inject);

          case 47:
            if (!(typeof nuxt_plugin_icon_0a99f419 === 'function')) {
              _context2.next = 50;
              break;
            }

            _context2.next = 50;
            return nuxt_plugin_icon_0a99f419(app.context, inject);

          case 50:
            if (!(typeof nuxt_plugin_nuxtsvgsprite_1fd790f8 === 'function')) {
              _context2.next = 53;
              break;
            }

            _context2.next = 53;
            return nuxt_plugin_nuxtsvgsprite_1fd790f8(app.context, inject);

          case 53:
            if (!(typeof nuxt_plugin_axios_566d83e6 === 'function')) {
              _context2.next = 56;
              break;
            }

            _context2.next = 56;
            return nuxt_plugin_axios_566d83e6(app.context, inject);

          case 56:
            if (!(typeof nuxt_plugin_capiplugin_26f5feed === 'function')) {
              _context2.next = 59;
              break;
            }

            _context2.next = 59;
            return nuxt_plugin_capiplugin_26f5feed(app.context, inject);

          case 59:
            if (!(process.server && typeof nuxt_plugin_nitrobridgeserver_499647d8 === 'function')) {
              _context2.next = 62;
              break;
            }

            _context2.next = 62;
            return nuxt_plugin_nitrobridgeserver_499647d8(app.context, inject);

          case 62:
            if (!(process.client && typeof nuxt_plugin_nitroclient_33e93c60 === 'function')) {
              _context2.next = 65;
              break;
            }

            _context2.next = 65;
            return nuxt_plugin_nitroclient_33e93c60(app.context, inject);

          case 65:
            if (!(process.client && typeof nuxt_plugin_echo_7481157c === 'function')) {
              _context2.next = 68;
              break;
            }

            _context2.next = 68;
            return nuxt_plugin_echo_7481157c(app.context, inject);

          case 68:
            if (!(typeof nuxt_plugin_gtm_5e4639ea === 'function')) {
              _context2.next = 71;
              break;
            }

            _context2.next = 71;
            return nuxt_plugin_gtm_5e4639ea(app.context, inject);

          case 71:
            if (!(process.client && typeof nuxt_plugin_flareclient_5d98532c === 'function')) {
              _context2.next = 74;
              break;
            }

            _context2.next = 74;
            return nuxt_plugin_flareclient_5d98532c(app.context, inject);

          case 74:
            if (!(typeof nuxt_plugin_auth_fb39deec === 'function')) {
              _context2.next = 77;
              break;
            }

            _context2.next = 77;
            return nuxt_plugin_auth_fb39deec(app.context, inject);

          case 77:
            // Lock enablePreview in context
            if (process.static && process.client) {
              app.context.enablePreview = function () {
                console.warn('You cannot call enablePreview() outside a plugin.');
              };
            } // Wait for async component to be resolved first


            _context2.next = 80;
            return new Promise(function (resolve, reject) {
              // Ignore 404s rather than blindly replacing URL in browser
              if (process.client) {
                var _router$resolve = router.resolve(app.context.route.fullPath),
                    _route = _router$resolve.route;

                if (!_route.matched.length) {
                  return resolve();
                }
              }

              router.replace(app.context.route.fullPath, resolve, function (err) {
                // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
                if (!err._isRouter) return reject(err);
                if (err.type !== 2
                /* NavigationFailureType.redirected */
                ) return resolve(); // navigated to a different route in router guard

                // navigated to a different route in router guard
                var unregister = router.afterEach( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(to, from) {
                    return regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            if (process.server && ssrContext && ssrContext.url) {
                              ssrContext.url = to.fullPath;
                            }

                            _context.next = 3;
                            return getRouteData(to);

                          case 3:
                            app.context.route = _context.sent;
                            app.context.params = to.params || {};
                            app.context.query = to.query || {};
                            unregister();
                            resolve();

                          case 8:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function (_x2, _x3) {
                    return _ref.apply(this, arguments);
                  };
                }());
              });
            });

          case 80:
            return _context2.abrupt("return", {
              store: store,
              app: app,
              router: router
            });

          case 81:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _createApp.apply(this, arguments);
}

export { createApp, NuxtError };